import React from "react"
  import {
    Container,
    Col,
    Row,
    Collapse,
    Navbar,
    NavbarToggler,
    NavbarBrand,
    Nav,
    NavItem,
    NavLink,
    UncontrolledDropdown,
    DropdownToggle,
    DropdownMenu,
    DropdownItem } from 'reactstrap'
    import logoblue from './images/logobluehigh.png'
    import facebook from './images/facebook.png'
    import twitter from './images/twitter.png'
    import whatsapp from './images/whatsapp.png'

    function Header(){
          return (
            <Container fluid className="header">
              <Row className="text-center">
                <Col xs="12" md="8" className="text-left align-items-end">
                <a href="https://aljazeera.com" target="_blank">
                    <img className="imagef float-left" alt="Al Jazeera" width="75px" height="auto" src={logoblue}/>
                  </a>
                  <div className="textboxessocial">
                  <p className="socialhead">DEATH FROM ABOVE</p>
                  <p className="socialsub georgia">Every Saudi coalition air raid on Yemen</p>
                    </div>
                </Col>
                <Col xs="12" md="4" className="socialbox align-self-end text-right">
                <Row className="socialbutton">
                <Col xs="4">
                <div className="socialbutton">
                  <a  href="https://www.facebook.com/sharer/sharer.php?u=https%3A%2F%2Finteractive.aljazeera.com%2Faje%2F2018%2FSaudi-Arabia-air-raids-on-Yemen%2Findex.html" target="_blank">
                    <img className="align-bottom" style={{verticalAlign: "text-bottom", padding:"1px 5px"}} alt="Facebook" width="40px" height="auto" src={facebook}/>
                  </a>
                  </div>
                  </Col>
                  <Col xs="4">
                  <div className="socialbutton">
                  <a href="https://twitter.com/intent/tweet?text=Yemen: Death from above https%3A%2F%2Finteractive.aljazeera.com%2Faje%2F2018%2FSaudi-Arabia-air-raids-on-Yemen%2Findex.html via @AJLabs" target="_blank">
                    <img className="align-bottom" style={{verticalAlign: "text-bottom", padding:"1px 5px"}} alt="Twitter" width="40px" height="auto" src={twitter}/>
                  </a>
                  </div>
                  </Col>
                  <Col xs="4">
                  <div className="socialbutton">
                  <a href="whatsapp://send?text=Yemen%3A%20Death%20from%20above%20https%3A%2F%2Finteractive.aljazeera.com%2Faje%2F2018%2FSaudi-Arabia-air-raids-on-Yemen%2Findex.html" target="_blank">
                    <img className="align-bottom" style={{verticalAlign: "text-bottom", padding:"1px 5px"}} alt="Whatsapp" width="40px" height="auto" src={whatsapp}/>
                  </a>
                  </div>
                  </Col>
                  </Row>
                  </Col>
              </Row>
            </Container> 
          )
        }

export default Header